import { Injectable, signal } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable, tap } from 'rxjs';
import { RailcardDto, RailcardsResponse } from '../models/railcards.model';

@Injectable({ providedIn: 'root' })
export class RailcardsService extends BaseApiService {
  readonly railcards = signal<RailcardDto[] | null>(null);

  getRailcards(): Observable<RailcardsResponse> {
    return this.get<RailcardsResponse>('/railcards').pipe(
      tap((railcardResponse) => {
        const sortedRailcards = (railcardResponse.railcards || []).sort((a, b) =>
          (a.railcardDescription || '').localeCompare(b.railcardDescription || '')
        );
        this.railcards.set(sortedRailcards);
      }),
    );
  }
}
